import { push } from 'react-router-redux';
import routes from 'library/Routes';
import { addSubscription } from 'actions/actions';
import { BLOCKED_STATUS } from 'constants/subscriptionStatus';

interface StoreLike {
  getState: () => { subscription?: { status?: string } | null };
  dispatch: (action: any) => unknown;
}

// What a business tab does on 403 SUBSCRIPTION_BLOCKED (see SubscriptionBlockedHandler.ts): mark the
// subscription blocked and open the "blocked" page - once. When the store already says BLOCKED the user
// is on (or being sent to) the blocked/billing pages, whose own requests may still get this 403; doing
// nothing then is what prevents a redirect loop.
//
// The subscription this tab holds was loaded while the studio was still active, so it lacks what the
// blocked page shows (willDeleteDate - "deleted in NaN days" without it). `loadSubscription`, when
// given, re-reads it right after the redirect; a failure there leaves the redirect as it is.
export function createSubscriptionBlockedHandler(
  store: StoreLike,
  loadSubscription?: () => Promise<unknown>
): () => void {
  return () => {
    const subscription = store.getState().subscription;
    if (subscription?.status === BLOCKED_STATUS) {
      return;
    }
    store.dispatch(addSubscription({ ...subscription, status: BLOCKED_STATUS }));
    store.dispatch(push(routes.blocked()));
    if (loadSubscription) {
      Promise.resolve()
        .then(loadSubscription)
        .then((fresh) => fresh && store.dispatch(addSubscription(fresh)))
        .catch(() => undefined);
    }
  };
}
